import { Mail } from "lucide-react";
import { useTranslate } from "ra-core";
import { useState } from "react";
import { Button } from "@/components/ui/button";

import {
  ComposeEmailDialog,
  type ComposeEmailDialogProps,
} from "./ComposeEmailDialog";

/** « Envoyer un e-mail » button of a record page, opening the compose window. */
export const SendEmailButton = ({
  className,
  ...props
}: Omit<ComposeEmailDialogProps, "open" | "onClose"> & {
  className?: string;
}) => {
  const translate = useTranslate();
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={className}
        onClick={() => setOpen(true)}
      >
        <Mail className="size-4" />
        {translate("crm.mail.compose.open")}
      </Button>
      <ComposeEmailDialog
        {...props}
        open={isOpen}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
